export default __webpack_public_path__ + "static/media/progress-arrow-ar.5b144665.svg";